import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatTooltip} from "@angular/material/tooltip";
import {UiConfig} from '@core/config/ui.config';

@Component({
  selector: 'ui-atom-button',
  standalone: true,
  imports: [CommonModule, MatTooltip],
  templateUrl: './ui-atom-button.component.html',
  styleUrl: './ui-atom-button.component.scss',
})
export class UiAtomButtonComponent {

  @Input() disabled = false;
  @Input() text = '';
  @Input() styling: 'filled' | 'outlined' | 'text' = 'filled';
  @Input() rules: 'main' | 'alert' | 'success' = 'main';
  @Input() fullWidth: boolean = false;
  @Input() isSubmit: boolean = false;
  @Input() tooltip: string = '';
  @Input() tooltipShowDelay = UiConfig.tooltip.showDelay;
  @Output() buttonClick = new EventEmitter<void>();
  @Input() withShadow = true;

  @ViewChild('buttonElement') private buttonElement!: ElementRef<HTMLButtonElement>;

  protected getButtonClasses() {
    return {
      'filled': this.styling === 'filled',
      'outlined': this.styling === 'outlined',
      'text': this.styling === 'text',
      'btnmain': this.rules === 'main',
      'btnalert': this.rules === 'alert',
      'btnsuccess': this.rules === 'success',
      'full-width': this.fullWidth,
      'no-shadow': !this.withShadow,
    };
  }

  onButtonClick(): void {
    this.buttonClick.emit();
  }

  /**
   * Sets focus on the button element.
   */
  public focus(): void {
    if (this.buttonElement && this.buttonElement.nativeElement) {
      this.buttonElement.nativeElement.focus();
    }
  }
}
